import { resolvePaymentCardBrand } from '@frontend/api-client';
import type { Card } from '@frontend/api-types';
import { Visa } from '@frontend/assets';
import { Image, LinkButton, Text, XStack, YStack } from '@frontend/web-react';
import { router } from '@frontend/web/router';

type PaymentMethodsCardProps = {
  cards?: Card[];
};

export const PaymentMethodsCard = ({ cards }: PaymentMethodsCardProps) => {
  const defaultCard = cards?.find((card) => card.isDefault);

  return (
    <YStack className="bg-trueWhite border-1 border-borderPrimary rounded-lg p-md gap-md">
      <YStack className="gap-sm">
        <Text color="primary" type="p-md">
          Payment methods
        </Text>
        <XStack className="gap-xs items-center flex-wrap">
          <Text color="secondary" type="p-sm">
            To change, add or update your card, go to
          </Text>
          <LinkButton
            accessibilityLabel="Go to payments"
            color="secondary"
            label="Payments"
            onClick={() => router.navigate({ to: '/app/settings/payments' })}
            type="p-sm"
            withUnderline
          />
        </XStack>
      </YStack>

      {defaultCard ? (
        <YStack accessibilityLabel="Default payment method" className="gap-sm">
          <XStack className="items-center justify-between border-1 border-borderPrimary rounded-lg p-md">
            <XStack className="items-center gap-sm">
              <Image
                source={resolvePaymentCardBrand(defaultCard.brand, { fallback: Visa })}
                style={{ height: 20, marginRight: 8, width: 32 }}
              />
              <Text type="h6">**** {defaultCard.lastFour}</Text>
            </XStack>
            <Text color="tertiary" type="p-sm">
              Exp {defaultCard.month}/{defaultCard.year}
            </Text>
          </XStack>
        </YStack>
      ) : (
        <Text color="secondary" type="p-md">
          No payment methods added
        </Text>
      )}
    </YStack>
  );
};
